const REJECTION_REASON = {
  BLURRY: '影像模糊無法辨識',
  WRONG_TYPE: '文件類型不符',
  EXPIRED: '文件已過期',
  HOLDER_MISMATCH: '資料與帳號持有人不符',
  INVALID_FORMAT: '檔案格式不符',
  // DUPLICATED: '此證件已由其他帳號上傳',
  OTHER: '其他',
} as const;

type RejectionReasonCode = keyof typeof REJECTION_REASON;

const REJECTION_REASON_OPTIONS = (
  Object.keys(REJECTION_REASON) as RejectionReasonCode[]
).map((value) => ({ value, label: REJECTION_REASON[value] }));

const buildRejectReason = (code: RejectionReasonCode, note: string) =>
  code === 'OTHER' ? note.trim() : REJECTION_REASON[code];

export { REJECTION_REASON, REJECTION_REASON_OPTIONS, buildRejectReason };

export type { RejectionReasonCode };
